


















































































import { PlanHeader } from '@/entity/Ppe/PlanHeader';
import { PPE_STATUS } from '@/services/Enums';
import { General } from '@/services/General';
import axios from 'axios';
import { Component, Vue } from 'vue-property-decorator';
import PlanDetails from '../PlanDetails.vue';

@Component({
    components: {
        PlanDetails
    }
})


export default class PendingPlansWidget extends Vue {
    idPlanDetail: string = null;
    planDetailEditMode: boolean = false;
    productsType: number = null; 

    loading: boolean = false;
    page: number = 1;
    resultsItems: any = {
        resultPage: new Array<PlanHeader>(),
        total: 0
    };
    selectedContractYear: number = 0;
    idCustomerDetail: string = '';
    numericIdSelected: number = 0;

    async mounted() {
        await this.searchPlansWidgetInfo(false);
    }

    isPendingCountryManagerEndorsment(plan: PlanHeader) {
        if (plan.isCountryManager 
            && (plan.target?.countryManagerEndorsement == null || plan.target?.countryManagerEndorsement?.trim() === '') 
            && plan.status == PPE_STATUS.TARGET_CHECK) {
            return true;
        }
        return false;
    }

    isPendingProductConfirmation(plan: PlanHeader) {
        if (plan.isPromotionRequester 
            && (plan.target?.productionConfirmation == null) 
            && plan.status == PPE_STATUS.TARGET_CHECK) {
            return true;
        }
        return false;
    }

    openPlan(plan: PlanHeader, forceOpen: boolean) {
        this.planDetailEditMode = true;
        this.idPlanDetail = plan.id;
        this.numericIdSelected = plan.numericId;
        this.$bvModal.show('plan-details-modal');
    }

    async postUpdatingPlan() {
        this.resultsItems = {
            resultPage: new Array<PlanHeader>(),
            total: 0
        };
        await this.searchPlansWidgetInfo(false, true);
    }

    async searchPlansWidgetInfo(switchPage: boolean, resetPagination: boolean = false) {
        this.loading = true;

        if (resetPagination) {
            this.page = 1;
        }
        else {
            if (switchPage)
                this.page = this.page + 1;
        }

        try {
            let results: any = await axios({
                method: 'post',
                url: General.GetApiUrl('/api/ppe/GetPendingPlansWithPagination'),
                data: {
                    CurrentPage: this.page,
                    PageSize: 4
                },
                withCredentials: true,
                responseType: 'json'
            });

            this.resultsItems.resultPage = this.resultsItems.resultPage.concat(results.data.listPage);
            this.resultsItems.total = results.data.total;
            this.syncPendingPlans();
            this.loading = false;
        } catch (error) {
            General.HandleError(error, this);
            this.loading = false
        }
    }

    syncPendingPlans() {
        this.$emit("pending-plans-sync", this.resultsItems.total);
    }
}
